export default __webpack_public_path__ + "static/media/team1.6803eb72.jpg";